import React, { Component } from "react";
import { SIDE_NAV_ITEMS, API_URLS } from "../../api-constant";
import NewNavBar from "../NavBar/Navbar";
import Sidebar from "../Sidebar/sidebar";
import ResponsiveSidebar from "../Sidebar/Responsive/SideBar";
import InvitationTabs from "./invitations";
import addAccessTokenToUrl from "../../Utils/Axios/addTokenToUrl";
import axios from "axios";
import { withRouter } from "react-router";
import Navbar from "../../../_components/common/Navbar";
import { toast } from "react-toastify";

const initialEmailFormObject = {
  inputType: "email",
  name: "name",
  inputId: "email",
  value: "",
};
const initialRelationFormObject = {
  inputType: "select",
  name: "relationship",
  inputId: "relationship",
  value: "",
};
export class Renderinvitationsflow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      sidebarOpen: false,
      receivedTab: true,
      sentTab: false,
      editModal: false,
      deleteModal: false,
      respondentEmail: "",
      respondentRelationship: "",
      reviewMode: false,
      respondentInvitationsModal: false,
      respondantConfirmModal: false,
      inputFields: [
        { ...initialEmailFormObject },
        { ...initialRelationFormObject },
      ],
      dropDownOptions: [],
      isChecked: false,
      isDisabled: true,
      enableNotification: false,
      receivedInvitations: [],
      sentRespondants: [],
      numberCount: "",
      completedCount: "",
      minRespondants: "",
      batchMinRespondants: "",
      getRespondantStatus: [],
      successMessage: "",
      respondantEmail: "",
      respondantUserAssessmentId: "",
      respondantIndividualId: "",
      filteredSentRespondants: null,
      sentRespondantsId: "",
      sentRespondantsFilteredId: "",
      userAssessmentId: "",
      assessmentUserId: "",
      accessorGroupId: "",
      relationShipId: "",
      updateMessage: "",
      setDropdownValue: "",
      collapseID: null,
      emailValue: [],
      relationShipValue: [],
      invitationsSuccessMessage: [],
      orgId: "",
      sellerId: "",
      idOfParticipant: "",
      isMultiRater: "",
    };
  }

  /* handle apis */
  accessorGroupApi = () => {
    const sellerId = this.state.sellerId;
    const orgId = this.state.orgId;
    /* accessor group api */
    axios
      .get(
        addAccessTokenToUrl(
          API_URLS.Respondent_Relation_Accessor_Dropdown({ sellerId, orgId })
        )
      )
      .then((response) => {
        this.setState({
          dropDownOptions: response.data.organisation_assessor_group_list,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };
  componentDidMount() {
    const id = this.props.match.params.id;
    const participantId = this.props.match.params.participant__id;
    const instrumentType = this.props.match.params.instrument__is_multi_rater;

    this.setState({ isLoading: true });

    /* user assessment get api */
    axios
      .get(addAccessTokenToUrl("/assessments/user/active/assessments/"))
      .then((response) => {
        response.data.user_assessments.map((getRespondants) => {
          {
            this.setState({
              batchMinRespondants: getRespondants.batch__min_respondent,
            });
            getRespondants.respondents.map((i) => {
              this.setState({
                getRespondantStatus: i,
              });
            });
          }
        });
        const filteredData = [];
        response.data.user_assessments.map((element) => {
          element.respondents.filter((filteredElement) => {
            if (
              filteredElement.assessment_status__status_name === "Completed"
            ) {
              return filteredData.push(filteredElement);
            }
          });
        });
        const getOnlyAssessmentStatus = filteredData.map((i) => {
          return i.assessment_status__status_name;
        });
        const filteredSentRespondants = response.data.user_assessments.find(
          (filteredRespondents) => {
            return filteredRespondents.id == id;
          }
        );
        this.setState(
          {
            sentRespondants: response.data.user_assessments,
            filteredSentRespondants,
            orgId: filteredSentRespondants.organisation,
            sellerId: filteredSentRespondants.seller,
            sentRespondantsId: id,
            sentRespondantsFilteredId: id,
            receivedInvitations: response.data.my_inivation,
            minRespondants: getOnlyAssessmentStatus,
            idOfParticipant: participantId,
            isMultiRater: instrumentType,
            isLoading: false,
          },
          () => {
            this.accessorGroupApi();
          }
        );
      })
      .catch((error) => {
        console.error(error);
        this.setState({ isLoading: false });
      });
  }

  handleReceivedTab = () => {
    this.setState({
      receivedTab: true,
      sentTab: false,
    });
  };

  handleSentTab = () => {
    this.setState({
      sentTab: true,
      receivedTab: false,
    });
  };

  handleModalClose = () => {
    this.setState({
      editModal: false,
      deleteModal: false,
      respondentInvitationsModal: false,
      respondantConfirmModal: false,
    });
  };

  handleEditModal = (email, relation, uid, rid, gid) => {

    this.setState({
      editModal: true,
      respondentEmail: email,
      respondentRelationship: relation,
      assessmentUserId: uid,
      relationShipId: rid,
      accessorGroupId: gid,
    });
  };

  handleDeleteModal = (email, respUserId, respRespondantId) => {
    this.setState({
      deleteModal: true,
      respondentEmail: email,
      respondantUserAssessmentId: respUserId,
      respondantIndividualId: respRespondantId,
    });
  };
  handleInvitationsModal = () => {
    this.setState({
      respondentInvitationsModal: true,
    });
  };
  /* handle on change invitations email */
  handleInvitationsEmail = (value) => {
    if (value.length == 6) {
      this.setState({
        isDisabled: false,
      });
    }
  };
  /* handle on change relation dropdown */
  handleRelationDropdown = () => {
    this.setState({
      isDisabled: false,
    });
  };
  /* invite respondants submit button handler */
  handleModalSubmit = () => {
    const id = this.props.match.params.id;
    const emailState = [];
    const relationState = [];
    const collectSuccessMessage = [];
    let breakLoop = false;
    this.state.inputFields.map((i, index) => {
      if (breakLoop) {
        return;
      }
      if (i.inputType == "email") {
        const inputId = document.getElementById(`email-${index}`);
        const showErrors = document.getElementById(`error-${index}`);
        const mailformat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (inputId.value == "") {
          showErrors.innerHTML = "Email cannot be empty";
          breakLoop = true;
          return;
        }
        if (!inputId.value.match(mailformat)) {
          showErrors.innerHTML = "Enter a valid email address";
          breakLoop = true;
          return;
        }
        emailState.push(inputId.value);
      } else {
        const selectId = document.getElementById(`select-${index}`);
        relationState.push(selectId.value);
      }
    });
    emailState.forEach((elem, index) => {
      /* call invite respondants api here */
      axios
        .post(
          addAccessTokenToUrl("/assessments/user/respondent/allot/assessment/"),
          {
            organisation_user_assessement_id: id,
            accessor_group_id: relationState[index],
            email_id: [elem],
          }
        )
        .then((response) => {
          collectSuccessMessage.push(response.data.message);
          this.setState({
            respondentInvitationsModal: false,
            respondantConfirmModal: true,
            isDisabled: true,
            inputFields: [initialEmailFormObject, initialRelationFormObject],
            invitationsSuccessMessage: collectSuccessMessage,
          });
          /* recall the user assessment get api on success */
          axios
            .get(addAccessTokenToUrl("/assessments/user/active/assessments/"))
            .then((response) => {
              const filteredSentRespondants = response.data.user_assessments.find(
                (filteredRespondents) => {
                  return filteredRespondents.id == id;
                }
              );
              this.setState({
                filteredSentRespondants,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        })
        .catch((error) => {
          console.error(error);
        });
    });
  };

  handleInputFields = () => {
    this.setState({
      inputFields: [
        ...this.state.inputFields,
        initialEmailFormObject,
        initialRelationFormObject,
      ],
      isChecked: !this.state.isChecked,
    });
    setTimeout(() => {
      this.setState({
        isChecked: false,
      });
    }, 2000);
  };
  handleModalFormSubmit = (e) => {
    e.preventDefault();
  };
  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };
  handleReminder = (idUser, emailRespondants, idRespondants) => {
    const userType = localStorage.getItem('usertype') || "";

    axios
      .post(
        addAccessTokenToUrl("/assessments/send/email/remainder/indivisual/"),
        {
          assessment_id: emailRespondants,
          respondent_id: idRespondants,
        }
      )
      .then((response) => {


        if (userType.includes("organisation_admin") || userType.includes("seller_admin")) {
          toast.success(response.data.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 1500,
          });
        }

        this.setState({
          successMessage: response.data.message,
          enableNotification: true,
          respondentEmail: idUser,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleDeleteRequest = (deleteUserAssessmentId, deleteRespondantId) => {
    const id = this.props.match.params.id;
    /* call delete api here */
    axios
      .post(
        addAccessTokenToUrl("/assessments/user/respondent/remove/assessment/"),
        {
          respondent_id: deleteRespondantId,
          user_assessment_id: deleteUserAssessmentId,
        }
      )
      .then((response) => {
        this.setState({
          successMessage: response.data.message,
        });
        /* recall the user active api when  the response is success */
        if (response.data.status) {
          axios
            .get(addAccessTokenToUrl("/assessments/user/active/assessments/"))
            .then((response) => {
              const filteredSentRespondants = response.data.user_assessments.find(
                (filteredRespondents) => {
                  return filteredRespondents.id == id;
                }
              );
              this.setState({
                sentRespondants: response.data.user_assessments,
                filteredSentRespondants,
                enableNotification: true,
                deleteModal: false,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleDropdownOptions = (dropDownId) => {
    this.setState({
      setDropdownValue: dropDownId,
    });
  };

  handleEditModalSubmit = (userid, respondantId, relationId) => {
    const id = this.props.match.params.id;

    // Disable the submit button or show a loading indicator here

    /* edit relation api */
    axios
      .post(
        addAccessTokenToUrl(
          `/assessments/user/respondent/edit/assessment/relation/${userid}/${respondantId}/`
        ),
        {
          accessor_group_id: this.state.setDropdownValue,
        }
      )
      .then((response) => {
        this.setState({
          updateMessage: response.data.message,
        });
        /* recall the user active api when the response is success */
        if (response.data.status) {
          return axios.get(addAccessTokenToUrl("/assessments/user/active/assessments/"));
        } else {
          // Handle unsuccessful edit here
          throw new Error("Edit was not successful");
        }
      })
      .then((response) => {
        const filteredSentRespondants = response.data.user_assessments.find(
          (filteredRespondents) => {
            return filteredRespondents.id == id;
          }
        );
        this.setState({
          filteredSentRespondants,
          enableNotification: true,
          editModal: false,
          respondentInvitationsModal: false,
        });
        // Show success message or notification here
      })
      .catch((error) => {
        console.error(error);
        // Show error message to the user
        // Don't close the modal here
      })
      .finally(() => {
        // Re-enable the submit button or hide the loading indicator here
      });
  };

  handleUnfilteredEditModalSubmit = (userid, respondantId, relationId) => {
    /* edit relation api */
    axios
      .post(
        addAccessTokenToUrl(
          `/assessments/user/respondent/edit/assessment/relation/${userid}/${respondantId}/`
        ),
        {
          accessor_group_id: this.state.setDropdownValue,
        }
      )
      .then((response) => {
        this.setState({
          updateMessage: response.data.message,
        });
        /* recall the user active api when  the response is success */
        if (response.data.status) {
          axios
            .get(addAccessTokenToUrl("/assessments/user/active/assessments/"))
            .then((response) => {
              this.setState({
                sentRespondants: response.data.user_assessments,
                enableNotification: true,
                editModal: false,
                respondentInvitationsModal: false,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };

  toggleCollapse = (collapseID) => {
    if (this.state.collapseID === collapseID) {
      this.setState({
        collapseID: null,
      });
    } else {
      this.setState({
        collapseID: collapseID,
      });
    }
  };

  setTabIndex = (index) => {
    this.setState({
      tabIndex: index,
    });
  };
  handleCloseNotification = () => {
    this.setState({
      enableNotification: false
    })
  }
  render() {
    const userType = localStorage.getItem('usertype') || "";
    return (
      <div>
        {userType.includes("organisation_admin") || userType.includes("seller_admin") ? (
          <Navbar />
        ) : (

          <NewNavBar
            enableNotification={this.state.enableNotification}
            handleNotification={this.handleNotification}
            successMessage={this.state.successMessage}
            respondentEmail={this.state.respondentEmail}
            updateMessage={this.state.updateMessage}
            handleCloseNotification={this.handleCloseNotification}
          />
        )}
        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (

          <Sidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
          />
        ) : null}
        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (
          <ResponsiveSidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
            sidebarOpen={this.state.sidebarOpen}
            onSetSidebarOpen={this.onSetSidebarOpen}
          />
        ) : null}
        <InvitationTabs
          isLoading={this.state.isLoading}
          tabIndex={this.state.tabIndex}
          setTabIndex={this.setTabIndex}
          receivedTab={this.state.receivedTab}
          sentTab={this.state.sentTab}
          handleReceivedTab={this.handleReceivedTab}
          handleSentTab={this.handleSentTab}
          editModal={this.state.editModal}
          deleteModal={this.state.deleteModal}
          handleEditModalSubmit={this.handleEditModalSubmit}
          handleEditModal={this.handleEditModal}
          handleDeleteModal={this.handleDeleteModal}
          respondentEmail={this.state.respondentEmail}
          respondentRelationship={this.state.respondentRelationship}
          reviewMode={this.state.reviewMode}
          respondentInvitationsModal={this.state.respondentInvitationsModal}
          handleInvitationsModal={this.handleInvitationsModal}
          inputFields={this.state.inputFields}
          handleInputFields={this.handleInputFields}
          dropDownOptions={this.state.dropDownOptions}
          handleInvitationsEmail={this.handleInvitationsEmail}
          isChecked={this.state.isChecked}
          isDisabled={this.state.isDisabled}
          handleModalFormSubmit={this.handleModalFormSubmit}
          respondantStatus={this.state.respondantStatus}
          receivedInvitations={this.state.receivedInvitations}
          sentRespondants={this.state.sentRespondants}
          minRespondants={this.state.minRespondants}
          getRespondantStatus={this.state.getRespondantStatus}
          batchMinRespondants={this.state.batchMinRespondants}
          handleReminder={this.handleReminder}
          respondantUserAssessmentId={this.state.respondantUserAssessmentId}
          respondantIndividualId={this.state.respondantIndividualId}
          handleDeleteRequest={this.handleDeleteRequest}
          filteredSentRespondants={this.state.filteredSentRespondants}
          sentRespondantsId={this.state.sentRespondantsId}
          sentRespondantsFilteredId={this.state.sentRespondantsFilteredId}
          handleModalClose={this.handleModalClose}
          assessmentUserId={this.state.assessmentUserId}
          accessorGroupId={this.state.accessorGroupId}
          relationShipId={this.state.relationShipId}
          handleDropdownOptions={this.handleDropdownOptions}
          handleUnfilteredEditModalSubmit={this.handleUnfilteredEditModalSubmit}
          handleRelationDropdown={this.handleRelationDropdown}
          collapseID={this.state.collapseID}
          toggleCollapse={this.toggleCollapse}
          userActiveDetails={this.state.userActiveDetails}
          handleModalSubmit={this.handleModalSubmit}
          respondantConfirmModal={this.state.respondantConfirmModal}
          invitationsSuccessMessage={this.state.invitationsSuccessMessage}
          idOfParticipant={this.state.idOfParticipant}
          isMultiRater={this.state.isMultiRater}
        />
      </div>
    );
  }
}

export default withRouter(Renderinvitationsflow);



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/index.js